import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { DeleteIcon, RenameIcon } from "../../Common/SvgIcon/CommonSvgIcons";

const ThreeDotButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  height: 100%;
`;
const DropdownMenu = styled.div`
  position: fixed; /* 🔥 KEY: prevents clipping */
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  // position: absolute;
  // top: 30px;
  // right: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0,0,0,0.2);
  border-radius: 6px;
  z-index: 1000000;
  min-width: 110px;
   
`;

const MenuItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: inherit;
  color:black;
  font-weight: 400;
  line-height: 24px;
    & > svg {  
      width: 14px; 
    }
    &:hover {
      background-color: #f2f2f2;
    }
    &:last-child {
      border-bottom: none;
    }
    &.delete {
      color: red;
    }
`;


const MenuItem2 = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: inherit;
  color:black;
  font-weight: 400;
  line-height: 24px;
    & > svg {  
      width: 18px; 
    }
    &:hover {
      background-color: #f2f2f2;
    }
    &:last-child {
      border-bottom: none;
    }
    &.delete {
      color: red;
    }
`;
const MenuWrapper = styled.div`
  position: relative;
  display: inline-block;

`;



const CrossButton = ({onClick,onRename }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const menuRef = useRef(null);

    const handleClick = (e) => {
        e.stopPropagation();

        const rect = e.currentTarget.getBoundingClientRect();

        const dropdownWidth = 20;
        const dropdownHeight = 120;

        let left = rect.right ;
        let top = rect.top;
        
        if (left + dropdownWidth > window.innerWidth) {
            left = rect.left - dropdownWidth - 0;
        }

        if (top + dropdownHeight > window.innerHeight) {
            top = rect.bottom - dropdownHeight;
        }

        setPosition({ top, left });
        setIsOpen((prev) => !prev);
    };

    // ✅ OUTSIDE CLICK HANDLER
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        const handleViewportChange = () => {
            setIsOpen(false);
        };

        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", handleViewportChange);
        }

        window.addEventListener("resize", handleViewportChange);

        return () => {
            window.removeEventListener("resize", handleViewportChange);

            if (window.visualViewport) {
                window.visualViewport.removeEventListener("resize", handleViewportChange);
            }
        };
    }, []);
    
    const handleClickBtn = (e,val) => {
        if(val == 'rename'){
            onRename(e)
        }else{
            onClick(e)
        }
        setIsOpen(false)
    }

    return (
        <MenuWrapper ref={menuRef} className='crossButton'>
            <ThreeDotButton onClick={handleClick}>⋯</ThreeDotButton>

            {isOpen && (
                <DropdownMenu top={position.top} left={position.left}>
                    <MenuItem onClick={(e)=>handleClickBtn(e,"rename")}>{RenameIcon} Rename</MenuItem>
                    <MenuItem2 onClick={(e)=>handleClickBtn(e,"delete")}>{DeleteIcon} Delete</MenuItem2>
                </DropdownMenu>
            )}
        </MenuWrapper>
    );
};

export default CrossButton;